const TOKEN_KEY = "authToken";

export function setToken(token) {
	localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
	return localStorage.getItem(TOKEN_KEY) || null;
}

export function removeToken() {
	localStorage.removeItem(TOKEN_KEY);
}

export { TOKEN_KEY };

/** Decode JWT payload without verifying signature (client expiry check only). */
export function parseJwtPayload(token) {
	try {
		const parts = String(token || "").split(".");
		if (parts.length < 2) return null;
		const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
		const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
		const json = atob(padded);
		return JSON.parse(json);
	} catch {
		return null;
	}
}

/**
 * True when token is missing exp, malformed, or past exp (with small skew).
 * Non-JWT opaque tokens return false (server 401 still handles those).
 */
export function isTokenExpired(token = getToken(), skewSeconds = 30) {
	if (!token) return true;
	const payload = parseJwtPayload(token);
	if (!payload || typeof payload.exp !== "number") return false;
	const now = Math.floor(Date.now() / 1000);
	return payload.exp <= now + skewSeconds;
}

let redirectingToLogin = false;

/** Clear session and send user to /login (once). */
export function clearSessionAndRedirectToLogin() {
	if (typeof window === "undefined") return;
	if (/^\/login\b/.test(window.location.pathname || "")) {
		removeToken();
		return;
	}
	if (redirectingToLogin) return;
	redirectingToLogin = true;
	try {
		removeToken();
		localStorage.removeItem("mfaEnabled");
		sessionStorage.removeItem("mfaRedirected");
	} catch {}
	window.location.replace("/login");
}

// Optional helper used by some API modules
export function getAuthHeader() {
	const token = getToken();
	return token ? { Authorization: `Bearer ${token}` } : {};
}
